import React, { useContext } from 'react'
import { Alert, Button, Stack, Typography } from '@mui/material'
import { EPCRContext } from '../EPCR'
import ImagingRequestsPanel from './ImagingRequestsPanel'
import { buildImagingEntry, syncImagingEntries } from './imagingAssessEntry'

// Assess-tab section for requesting imaging studies. Requests live in their
// own collection keyed by the record id, so the record needs its first
// autosave before one can be raised.
const Imaging = ({ onClose }) => {
  const { formID, formValues, handleChange } = useContext(EPCRContext)

  // Each request also keeps a summary entry in assess.modules so the study
  // shows in the assessment flow (editor list, read-only view, PDF)
  const appendAssessEntry = (request) =>
    handleChange({
      moduleName: 'assess',
      field: 'modules',
      value: [
        ...(formValues?.assess?.modules ?? []),
        buildImagingEntry(request),
      ],
    })

  const syncAssessEntry = (request) =>
    handleChange({
      moduleName: 'assess',
      field: 'modules',
      value: syncImagingEntries(formValues?.assess?.modules, request),
    })

  const removeAssessEntry = (request) =>
    handleChange({
      moduleName: 'assess',
      field: 'modules',
      value: (formValues?.assess?.modules ?? []).filter(
        (module) => module.imagingRequestId !== request._id,
      ),
    })

  return (
    <Stack gap={2}>
        <Stack gap={1}>
          <Typography variant="title3">Imaging Studies</Typography>
          {formID ? (
            <ImagingRequestsPanel
              epcrID={formID}
              allowNewRequests
              onRequestCreated={appendAssessEntry}
              onRequestUpdated={syncAssessEntry}
              onRequestDeleted={removeAssessEntry}
            />
          ) : (
            <Alert severity="info">
              The record is being saved — imaging can be requested in a few
              seconds.
            </Alert>
          )}
        </Stack>
      {onClose && (
        <Button variant="contained" color="primary" fullWidth onClick={onClose}>
          Close
        </Button>
      )}
    </Stack>
  )
}

export default Imaging
